import React, { useRef, useState, useEffect } from "react";

//loaders
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

import ReactECharts from "echarts-for-react";
import html2canvas from "html2canvas";
import JSZip from "jszip";

import Button from "@mui/material/Button";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';

import { MainButton } from "../../SXStyle";
import { excelAFecha } from "../../functions/functions.js";

function OnzasGraphs(props) {

  const { 
    visible, 
    dataExcel, 
    openLoader, 
    setOpenLoader,
    fechaInicio,
    fechaFinal,
    yAxis,
    yInter,
    y2Axis,
    y2Inter,
    text,
    subText
  } = props;

  const chartRef = useRef(null);

  const [dataGrafica, setDataGrafica] = useState({
    fechas: [],
    oz_au_plan: [], //eje x
    acumulado_plan_oz_au: [], //eje y
    oz_au_real_ocm: [], //eje x
    acumuluado_real_oz_ocm: [], //eje y
  });

  const filas = ["Título 1", "Título 2", "Título 3", "Título 4", "Título 5"];
  const columnas = Array.from({ length: 31 }, (_, i) => i + 1);

  /*filtra los registros por fecha y obtiene solos los registros que se van a ocupar
    para graficas */
  useEffect(() => {
    if (dataExcel.length > 0) {
      fetchExcel(fechaInicio, fechaFinal);
      setOpenLoader(false);
    }
  }, [dataExcel, fechaInicio, fechaFinal]);

  useEffect(() => {
    // Forzar resize cuando los datos cambian o cuando se hace visible
    if (chartRef.current && dataExcel.length > 0) {
      chartRef.current.getEchartsInstance().resize();
    }
  }, [dataExcel, visible]);

  const fetchExcel = async (fechaInicio, fechaFinal) => {
    try {
    
      let _fechas = [];
      let _oz_au_plan = []; //eje x
      let _acumulado_plan_oz_au = []; //eje y
      let _oz_au_real_ocm = []; //eje x
      let _acumuluado_real_oz_ocm = []; //eje y

      //filtra los registros por fecha y añade una columna nueva (fecha string)
      const _datosExcel = dataExcel
        .filter((row) => row[0] >= fechaInicio && row[0] <= fechaFinal)
        .map((row) => {
          _fechas.push(excelAFecha(row[0]));
          _oz_au_plan.push(row[11]);
          _acumulado_plan_oz_au.push(row[12]);
          _oz_au_real_ocm.push(row[23]);
          _acumuluado_real_oz_ocm.push(row[24]);
        });

      setDataGrafica({
        fechas: _fechas,
        oz_au_plan: _oz_au_plan,
        acumulado_plan_oz_au: _acumulado_plan_oz_au,
        oz_au_real_ocm: _oz_au_real_ocm,
        acumuluado_real_oz_ocm: _acumuluado_real_oz_ocm,
      });
    } catch (err) {
      console.error(err);
    }
  };

  const option = {
    title: {
      text: text,
      subtext: subText,
      left: 'center',
      top: 40,
      textStyle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: '#7b7b7b'
      },
      subtextStyle: {
        fontSize: 14,
        fontWeight: 'bold',
        color: '#9c9c9c'
      }
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "cross",
        crossStyle: {
          color: "#999",
        },
      },
    },
    toolbox: {
      feature: {
        dataView: {
          show: true,
          readOnly: true,
          optionToContent: function (opt) {
            const categorias = opt.xAxis[0].data;

            const seriesMap = {};
            opt.series.forEach((s) => {
              seriesMap[s.name] = s.data;
            });

            // Encabezados personalizados
            const headers = [
              "Fecha",
              "Oz Au_Plan",
              "Oz Au_Real_OCM",
              "Acumulado Plan Oz Au",
              "Acumulado Real Oz Au OCM",
            ];

            let table = `
              <table style="width:100%;border-collapse:collapse;text-align:center;" border="1">
                <thead>
                  <tr>
                    ${headers
                      .map(
                        (h) =>
                          `<th style="padding:4px;background:#f2f2f2">${h}</th>`
                      )
                      .join("")}
                  </tr>
                </thead>
                <tbody>
            `;

            // Recorrer todas las fechas
            for (let i = 0; i < categorias.length; i++) {
              table += "<tr>";
              table += `<td>${categorias[i]}</td>`;
              table += `<td>${format(seriesMap["Oz Au_Plan"]?.[i])}</td>`;
              table += `<td>${format(seriesMap["Oz Au_Real_OCM"]?.[i])}</td>`;
              table += `<td>${format(
                seriesMap["Acumulado Plan Oz Au"]?.[i]
              )}</td>`;
              table += `<td>${format(
                seriesMap["Acumulado Real Oz Au OCM"]?.[i]
              )}</td>`;
              table += "</tr>";
            }

            table += "</tbody></table>";
            return table;

            // Función de formato segura
            function format(val) {
              return isNaN(val) || val === null || val === ""
                ? "---"
                : parseFloat(val).toFixed(2);
            }
          },
        },

        //otros tipos de graficas
        magicType: {
          show: true,
          type: ["line", "bar"],
          title: {
            line: "Cambiar a Línea",
            bar: "Cambiar a Barra",
          },
        },
        restore: { show: true },
        saveAsImage: { show: true },
      },
    },
    //leyendas y data
    legend: {
      data: [
        "Oz Au_Plan",
        "Oz Au_Real_OCM",
        "Acumulado Plan Oz Au",
        "Acumulado Real Oz Au OCM",
      ],
    },
    xAxis: [
      {
        type: "category",
        data: dataGrafica.fechas,
        axisPointer: {
          type: "shadow",
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "AUEQ ONZAS",
        min: 0,
        max: yAxis,
        interval: yInter,
        axisLabel: {
          formatter: "{value}",
        },
      },
      {
        type: "value",
        name: "Acumulado Plan OZ AU",
        min: 0,
        max: y2Axis,
        interval: y2Inter,
        axisLabel: {
          formatter: "{value}",
        },
      },
    ],
    series: [
      {
        name: "Oz Au_Plan",
        type: "bar",
        itemStyle: {
          color: "#99abd9",
        },
        label: {
          show: true,
          position: "top",
          fontSize: 10,
          color: "#7e7e7e",
          formatter: (val) => {
            return isNaN(val.value) ? "ø" : parseFloat(val.value).toFixed(2);
          },
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.oz_au_plan,
      },
      {
        name: "Oz Au_Real_OCM",
        type: "bar",
        itemStyle: {
          color: "#f5b498",
        },
        label: {
          show: true,
          position: "top",
          fontSize: 10,
          color: "#7e7e7e",
          formatter: (val) => {
            return isNaN(val.value) ? "ø" : parseFloat(val.value).toFixed(2);
          },
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.oz_au_real_ocm,
      },
      {
        name: "Acumulado Plan Oz Au",
        type: "line",
        yAxisIndex: 1,
        itemStyle: {
          color: "#203864",
        },
        lineStyle: {
          width: 3,
          type: "solid",
        },
        label: {
          show: true,
          position: "right",
          fontSize: 8,
          color: "#7f7a77",
          backgroundColor: "#d7dff1",     // color de fondo
          borderRadius: 4,                // bordes redondeados
          padding: [4, 5],                // espacio interno: [vertical, horizontal]
          formatter: (val) => {
            return isNaN(val.value) ? "ø" : parseFloat(val.value).toFixed(2);
          },
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.acumulado_plan_oz_au,
      },
      {
        name: "Acumulado Real Oz Au OCM",
        type: "line",
        yAxisIndex: 1,
        itemStyle: {
          color: "#ff0000",
        },
        lineStyle: {
          width: 3,
          type: "solid",
        },
        label: {
          show: true,
          position: "top",
          fontSize: 8,
          fontWeight: 'bold',
          color: "#7f7a77",
          backgroundColor: "#fce4d3",     // color de fondo
          borderRadius: 4,                // bordes redondeados
          padding: [4, 5],                // espacio interno: [vertical, horizontal]
          formatter: (val) => {
            return isNaN(val.value) ? "ø" : parseFloat(val.value).toFixed(2);
          },
        },
        tooltip: {
          valueFormatter: function (value) {
            return isNaN(value) || value === null || value === ""
              ? "ø"
              : parseFloat(value).toFixed(2);
          },
        },
        data: dataGrafica.acumuluado_real_oz_ocm,
      },
    ],
  };

  // Manejar evento de restauración
  const onEvents = {
    restore: () => {
      // Reaplica el gráfico original
      chartRef.current.getEchartsInstance().setOption(option, true);
    },
  };

  /*
  const handleSaveImage = async() => {
    const echartsInstance = chartRef.current.getEchartsInstance();
    const imageURL = echartsInstance.getDataURL({
      type: 'png',
      pixelRatio: 2,
      backgroundColor: '#fff'
    });
    // Aquí puedes colocar tu código extra
    // Ejemplo: muestra alerta, registra log, actualiza estado, etc.

    // Dispara la descarga
    const a = document.createElement('a');
    a.href = imageURL;
    a.download = 'grafica.png';
    a.click();

    await exportTableToPNG();
  };


  const exportTableToPNG = async () => {
    const element = document.getElementById("tabla-datos");
    // Guarda los estilos originales
    const originalWidth = element.style.width;
    const originalOverflow = element.style.overflow;
    // Expande la tabla al tamaño completo
    element.style.width = element.scrollWidth + "px";
    element.style.overflow = "visible";

    const canvas = await html2canvas(element);

    // Restaura los estilos
    element.style.width = originalWidth;
    element.style.overflow = originalOverflow;

    const link = document.createElement("a");
    link.download = "grafica_tabla.png";
    link.href = canvas.toDataURL("image/png");
    link.click();
  };
  */

  //guarda la grafica y la tabla en un zip
  const handleSaveImage = async (text) => {
    const zip = new JSZip();

    // 1. Genera la imagen del gráfico
    const echartsInstance = chartRef.current.getEchartsInstance();
    const imageURL = echartsInstance.getDataURL({
      type: 'png',
      pixelRatio: 2,
      backgroundColor: '#fff'
    });
    const graficaBlob = await (await fetch(imageURL)).blob();
    zip.file("grafica.png", graficaBlob);

    // 2. Genera la imagen de la tabla
    const tablaBlob = await exportTableToBlob();
    zip.file("grafica_tabla.png", tablaBlob);

    // 3. Genera y descarga el ZIP
    const content = await zip.generateAsync({ type: "blob" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(content);
    a.download = text + ".zip";
    a.click();

  };

  //convierte la tabla de datos en un blob
  const exportTableToBlob = async () => {
    const element = document.getElementById("tabla-datos");
    const originalWidth = element.style.width;
    const originalOverflow = element.style.overflow;

    element.style.width = element.scrollWidth + "px";
    element.style.overflow = "visible";

    const canvas = await html2canvas(element);

    element.style.width = originalWidth;
    element.style.overflow = originalOverflow;

    return await new Promise((resolve) =>
      canvas.toBlob((blob) => resolve(blob), "image/png")
    );
  };
  
  return (
    <div className="p-4 rounded-lg shadow-lg  bg-blanco border-gray-600 mt-1 w-full">
      {/* Loader */}
      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={openLoader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <div style={{ width: "100%", height: "70vh" }}>
        <ReactECharts
          ref={chartRef}
          option={option}
          onEvents={onEvents}
          style={{ width: "100%", height: "100%" }}
        />
      </div>

      {/* Estadisticas */}
      <div id="tabla-datos" className="overflow-x-auto border rounded-lg">
        <div className="inline-block min-w-full">
          <div
            className="grid"
            style={{
              gridTemplateColumns: `150px repeat(${dataGrafica.oz_au_plan.length}, auto)`,
              gridTemplateRows: "repeat(5, auto)",
            }}
          >

            {/* Fechas */}
            <div className="border border-gray-300 p-2"></div>
                
            {dataGrafica.fechas.map((col, colIndex) => (
              <div
                key={`cell-${colIndex}`}
                className="border border-gray-300 p-2 text-inputs text-[10px]"
              >
                {col}
              </div>
            ))}
              

            {/* Oz Au_Plan */}
            <div className="border border-gray-300 p-2 font-bold bg-gray-200 text-[10px] flex ">
              <div className="bg-[#b0c2ee] w-[30px] h-[20px] mt-[2px] mr-3"></div>
              <p className="mt-1"> Oz Au_Plan </p>
            </div>
                
            {dataGrafica.oz_au_plan.map((col, colIndex) => (
              <div
                key={`cell-${colIndex}`}
                className="border border-gray-300 p-2 text-inputs text-[10px]"
              >
                {typeof col === 'number' ? col.toFixed(2) : ""}
              </div>
            ))}


            {/* Oz Au_Real_OCM  */}
            <div className="border border-gray-300 p-2 font-bold bg-gray-200 text-[10px] flex">
              <div className="bg-[#f5b498] w-[30px] h-[20px] mt-[2px] mr-3"></div>
              <p className="mt-1"> Oz Au_Real_OCM </p>
            </div>
                
            {dataGrafica.oz_au_real_ocm.map((col, colIndex) => (
              <div
                key={`cell-${colIndex}`}
                className="border border-gray-300 p-2 text-inputs text-[10px]"
              >
                {typeof col === 'number' ? col.toFixed(2) : ""}
              </div>
            ))}


            {/* Acumulado PLAN Oz Au */}
            <div className="border border-gray-300 p-2 font-bold bg-gray-200 text-[10px] flex ">
              <div> 
                <div className="flex items-center mt-[5px]">
                  <div className="w-2 h-0.5 bg-[#203864]"></div>
                  <div className="w-3 h-3 rounded-full bg-[#203864]"></div>
                  <div className="w-2 h-0.5 bg-[#203864]"></div>
                </div>
              </div>
              
              <p className="ml-3 mt-[-2px]"> Acumulado PLAN Oz Au </p>
            </div>
                
            {dataGrafica.acumulado_plan_oz_au.map((col, colIndex) => (
              <div
                key={`cell-${colIndex}`}
                className="border border-gray-300 p-2 text-inputs text-[10px]"
              >
                {typeof col === 'number' ? col.toFixed(2) : ""}
              </div>
            ))}


            {/* Acumulado REAL Oz Au OCM */}
            <div className="border border-gray-300 p-2 font-bold bg-gray-200 text-[10px] flex ">
              <div> 
                <div className="flex items-center mt-[5px]">
                  <div className="w-2 h-0.5 bg-gray-500"></div>
                  <div className="w-3 h-3 rounded-full bg-[#ff0000]"></div>
                  <div className="w-2 h-0.5 bg-gray-500"></div>
                </div>
              </div>
              
              <p className="ml-3 mt-[-2px]"> Acumulado REAL Oz Au OCM </p>
            </div>
                
            {dataGrafica.acumuluado_real_oz_ocm.map((col, colIndex) => (
              <div
                key={`cell-${colIndex}`}
                className="border border-gray-300 p-2 text-inputs text-[10px]"
              >
                {typeof col === 'number' ? col.toFixed(2) : ""}
              </div>
            ))}
          </div>
        </div>
      </div>

      <Button
        onClick={() => handleSaveImage(text)}
        variant="contained"
        sx={{ ...MainButton, width: "120px" }}
        endIcon={<CloudDownloadIcon />}
      >
        Exportar
      </Button>

    </div>
  );
}

export default OnzasGraphs;
